import fecha from 'fecha';
import { Advisors } from '../../redux/advisors/state';
import { currency } from '../formatting/currency';
import { dateDifferenceString } from '../formatting/date-difference';
import { RateQuote } from '../rate-quote/types';

export const computeSummary = (rqr: RateQuote['rateQuoteRequest'], advisors: Advisors) => {
  const { purpose, requester } = rqr;

  const summary = [['Type', purpose === 'purchase' ? 'Purchase' : 'Refinance']];

  switch (rqr.purpose) {
    case 'purchase':
      const { closeDate } = rqr;
      const propertyValue = rqr.purchasePrice;
      const acceptedOffer = rqr.acceptedOfferId;

      summary.push(
        ['Accepted Offer', acceptedOffer ? 'Yes' : 'No'],
        [
          'Close Date',
          closeDate
            ? `${fecha.format(new Date(closeDate), 'MM/DD/YY')} (${dateDifferenceString(
                Date.now(),
                closeDate
              )})`
            : ''
        ],
        ['Purchase Price', currency(propertyValue, 0)]
      );
      break;
    case 'refinance':
      const existingLoans = rqr.productSet[0].existingLoans;
      const primaryLoan = existingLoans.find((loan) => loan.existingLoanType === 'Primary') || {
        amount: 0
      };
      summary.push([
        'Existing Primary',
        currency('amount' in primaryLoan ? primaryLoan.amount : 0, 0)
      ]);
      break;
  }

  let owner = '';
  if (requester) {
    if (advisors[requester]) {
      owner = advisors[requester].name.full;
    } else {
      owner = requester;
    }
  }

  summary.push(['Deal Owner', owner]);

  return summary;
};
